import React, { useRef } from "react";
import Block from "@/ui/atoms/Block";
import clsx from "clsx";
import { Responsive, WidthProvider } from "react-grid-layout";
import type GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const ResponsiveGridLayout = WidthProvider(Responsive);

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type TDraggableGridNode = {
    element: React.ReactNode;
    options: GridLayout.Layout & {
        boxed?: boolean;
    };
};

export type TDraggableGridProps = Omit<BoxProps, "children"> & {
    nodes: TDraggableGridNode[];
    options: GridLayout.ResponsiveProps;
};

const testId = "DraggableGrid";

const DraggableGrid = (props: TDraggableGridProps) => {
    const { sx, nodes, className, options, ...otherProps } = props;

    const gridRef = useRef<GridLayout>(null);
    const layouts: GridLayout.Layouts = {
        lg: nodes.map(node => node.options),
    };

    return (
        <>
            <Box
                data-testid={testId}
                className={clsx([testId, className, "grid-stack"])}
                sx={{
                    ...sx,
                    width: options.width,
                }}
                ref={gridRef}
                {...otherProps}
            >
                <ResponsiveGridLayout
                    className="layout"
                    layouts={layouts}
                    rowHeight={50}
                    width={1200}
                    {...options}
                >
                    {nodes.map(node => (
                        <div key={node.options.i}>
                            {node.options?.boxed !== false ? (
                                <Block>{node.element}</Block>
                            ) : (
                                node.element
                            )}
                        </div>
                    ))}
                </ResponsiveGridLayout>
            </Box>
        </>
    );
};

export default DraggableGrid;
